import { Outlet, useLocation, useParams } from "react-router-dom";
import { Box, Container, Paper, Stack, Typography, useTheme } from "@mui/material";
import { useAppSelector } from "@/hooks";
import useOrganizationId from "@/hooks/useOrganizationId";
import Header from "@/features/catalog/components/AppBar";
import { useMemo } from "react";

const CatalogLayout = () => {
  const { quoteId } = useParams();
  const { pathname } = useLocation();
  const organizationId = useOrganizationId();
  const org = useAppSelector((state) => state.organizations[organizationId]);
  const items = useAppSelector((state) => state.quote.items);
  const theme = useTheme();

  const headerTitle = useMemo(() => {
    switch (pathname) {
      case "/catalogo":
        return "Catálogo";
      case "/checkout":
        return "Cotización";
      case "/contacto":
        return "Contacto";
      case `/cotizacion/${quoteId}`:
        return "Cotización";
    }
  }, [pathname, quoteId]);

  const menu = useMemo(() => {
    const selectedWebsite = org?.websites?.find((w) => w.id === org?.website);
    return selectedWebsite?.menu;
  }, [org?.website, org?.websites]);

  return (
    <Stack sx={{ backgroundColor: "#DDEAFD", height: "100%" }}>
      {/* header */}
      <Header logo={org?.logo as string} phone={org?.phone as number} products={items} menu={menu as []} />

      {/* body */}
      <Stack flex={1} sx={{ backgroundColor: "#DDEAFD" }}>
        <Box
          style={{
            height: "150px",
            display: "flex",
            justifyContent: "center",
            backgroundColor: theme.palette.primary.main,
            paddingBottom: "12px",
          }}
        >
          <Container
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography variant="h1" color="white" paddingX={3} sx={{ fontWeight: 400 }}>
              {headerTitle}
            </Typography>
          </Container>
        </Box>
        <Container
          style={{
            marginTop: "-24px",
            marginBottom: "48px",
          }}
        >
          <Paper sx={{ borderRadius: "16px" }}>
            <Outlet />
          </Paper>
        </Container>
      </Stack>
      {/* footer */}
      <Stack
        sx={{
          padding: "24px",
          backgroundColor: "whitesmoke",
        }}
      >
        <Container>
          <Typography> Todos los derechos reservados 2025</Typography>
        </Container>
      </Stack>
    </Stack>
  );
};

export default CatalogLayout;
